export const constantString = {
  LOGIN: "login",
  LOGIN_YOUR_ACCOUNT: "login_account",
  FORGOT_PASSWORD: "forgot_password",
  CREATE_NEW_ACCOUNT: "create_new_account?",
  CREATE_YOUR_ACCOUNT: "create_your_account",
  FIELDS_ARE_REQUIRED: "fields_are_required.",
  SIGN_UP: "sign_up",
  HAVE_AN_ACCOUNT: "have_an_account?",
  ENTER_OTP_VERIFY: "enter_otp_verify",
  EMAIL_VERIFICATION_TEXT: "email_verfication_text",
  VERIFY: "verify",
  DID_NOT_RECEIVE_CODE: "didn’t_receive_code?",
  RESEND_OTP: "resend_otp",
  CUSTOMER_DETAILS: "customer_details",
  VERIFIED: "verified",
  PAY_USING_QR: "pay_using_qr",
  APPOINTMENT_DETAILS: "appointment_details",

  Home: "Home",
  ADD_NEW: "add_new",

  ADD_SERVICE: "add_service",

  WELCOME: "welcome_aboard",
  THANKS_DESCRIPTION: "thanks_description",

  ADD_NEW_CATEGORY: "add_new_category",
  CALENDAR: "calendar",

  ADD_SERVICES: "add_services",
  VIEW_STAFFS: "view_staffs",

  LOGOUT: "logout",
  APPOINTMENT_COMPLETED_SUCCESSFULLY: "appointment_completed_successfully",
  ADD_CUSTOMER: "add_customer",
  CONFIRM_DELETE: "confirm_delete",
  DELETE: "delete",
  DELETE_TEXT: "delete_text",
  CONFIRM: "confirm",
  CANCEL: "cancel",
  DOWNLOAD: "download",
  ADD_NEW_CUSTOMER: "add_new_customer",
  NO_DATA: "no_data",
  STATUS: "status",
  NAME: "name",
  NO_CLIENT_SELECTED: "no_client_selected",
  SELECT_THERAPIST: "select_therapist",
  SCHEDULER_DATA: "scheduler_data",
  ADD_STAFF: "add_staff",
  ADVANCED_FILTER: "advanced_filter",
  APPOINTMENT_COMPLETED: "appointment_scheduled",
  DOWNLOAD_CSV: "download_csv",
  CSV_DOWNLOAD_OPTION: "csv_download_option",
  STATUS_VIEW: "status_view",

  SCHEDULER_DASHBOARD: "scheduler_dashoboard",
  CALENDER: "calender",
  CATALOGUE: "catalogue",
  TEAM: "team",
  ATTENDENCE: "attendence",
  ANALYTICS_REPORT: "analytic_report",

  TODAYS_SALE: "todays_sale",
  TODAYS_CANCEL: "todays_cancel",
  TODAYS_CUSTOMER: "todays_customer",
  TODAYS_APPOINTMENT: "todays_appointment",

  NO_APPOINTMENTS: "no_appointment",

  TEAM_ENGAGE: "team_engage",
  TEAM_SERVICE: "team_service",

  TEAM_MEMBER: "team_member",
  SERVICES: "services",

  COMPLETED: "completed",
  UPCOMING: "upcoming",
  CANCELLED: "cancelled",

  APPOINTMENT_STATUS: "appointment_status",
  CUSTOMER: "customer",
  COMMENTS: "comments",

  BOOKING_COMMENTS: "booking_comments",
  SELECT_SERVICE: "select_service",

  SELECT_STAFF: "select_staff",

  SERVICE_NAME: "service_name",
  REQUIRED_TIME: "time_required",

  ACTION: "action",

  LAST_NAME: "last_name",
  FIRST_NAME: "first_name",
  MOBILE: "mobile",
  GENDER: "gender",

  THANKS: "thanks",
  EMAIL_SENT: "email_sent",

  DONE: "done",

  SEARCH_CATEGORY: "search_category",
  EDIT: "edit",
  DELETE_BTN: "delete_btn",

  UPDATE_CATEGORY: "update_category",
  ADD_CATEGORY: "add_new_category",

  CATEGORY_NAME: "category_name",
  ENABLE_APPOINTMENT: "enable_appointment",

  UPDATE_SERVICE: "update_services",
  SELECT_CATEGORY: "select_category",

  TIME_IN_MIN: "time_in_min",
  DESCRIPTION: "description",
  MANAGE_STAFF: "manage_staff",
  DOB: "dob",
  END_DATE: "end_date",
  EMPLOYEE_STATUS: "employee_state",
  STREET: "street",
  ADDRESS: "address",
  TITLE: "title",
  EMPLOYEE_CODE: "employee_code",
  EMPLOYEE_NAME: "employee_name",
  LEAVE: "leave",
  UPDATE_ATTENDENCE: "update_attendence",
  CITY: "city",
  STATE: "state",
  POSTAL_CODE: "postal_code",
  COUNTRY: "country",

  CUSTOMER_NAME: "customer_name",
  CUSTOMER_EMAIL: "customer_email",
  CUSTOMER_MOBILE: "customer_mobile",
  APPLICATION_STATUS: "application_status",
  AMOUNT: "amount",

  SET_BUSINESS_PREFERENCE: "set_bussiness_prefrence",
  OPEN_TIME: "open_time",
  CLOSE_TIME: "close_time",

  PERSONAL_DETAILS: "personal_details",
  JOB_DETAILS: "job_details",
  EMAIL: "email",

  PHONE_NUMBER: "phone_number",
  START_DATE: "start_date",
  NOTE: "note",

  ADD_SHIFT: "add_shift",
  THIS_SHIFT: "this_shift",

  MESSAGE_ANOTHER_TIME: "message_choose_another_time",
  STAFF_NAME: "staff_name",

  TRANSACTION_ID: "transaction_id",
  CREATED_AT: "createdAt",
  CURRENCY: "currency",
  SECRET_KEY: "secret_key",
  DASMID: "dasmid",

  AMOUNT_PAID: "amount_paid",
  SKIP: "skip",
  RESEND_LINK: "resent_links",
  PROCCED_PAYMENT: "procced_payment",

  SEND_PAYMENT_LINK: "send_payment_link",
  APPOINTMENT_REPORT: "appointrment_report",
  PAYMENT_TRANSACTION_REPORT: "payment_transaction_report",
  GATEWAY_TRANSACTION_ID: "gateway_transaction_id",
  PAYMENT_FILTER: "payment_filter",

  PAYMENT_TRANSACTION: "payment_transaction",
  TOTAL: "Total",
  BALANCE: "balance",
  QR_CODE: "qr_code",

  SET_UP_WIZARD: "set_up_wizard",
  NO_CATEGORY: "no_category",
  NO_STAFF: "no_staff",
  NO_SEARCH: "no_search",

  ASSIGN_SERVICE: "assign_service",
  SELECT_CATEGORY_WITH_SERVICE: "select_category_with_service",
  SELECT_ALL_SERVICE: "select_all_services",
  COPY_SCHEDULE_TITLE: "copy_schedule_title",
  SELECT: "select",
  TIME: "time",
  DATE: "date",
  DAY: "day",
  SAVE: "save",

  ALL_APPOINTMENT: "all_appointment",
  SALES_BY_SERVICE: "sales_by_service",
  SALES_BY_STAFF: "sales_by_staff",
  SALES_BY_CUSTOMER: "sales_by_customer",
  ALL: "all",
  THIS_WEEK: "this_week",
  THIS_MONTH: "this_month",
  THIS_YEAR: "this_year",

  COPY_LINK:"copy_link",
  FROM:'from',
  TO:'to',
  SELECT_CUSTOMER:'select_customer',
  SEARCH:'search',

  GATE_WAY_URL:'gate_way_url',
  X_API_KEY:'x_api_key',


  ADD_STORE:"Add Store",
  UPDATE_STORE:"Update Store",
  STORE_STATUS:"Store Status",

  DASHBOARD:"dashboard",
  MULTI_STORE:"Multi Store",
  ADD_LOCATION:"Add Location",
  UPDATE_STORE_LOCATION:"Update Location",
  DELETE_STORE:"Delete Store",
  CHANGE_STORE:"Change Store",
  UPDATE_CUSTOMER:"update_customer"
};

export const validationMessages = {
  EMAIL_REQUIRED: "Email is Required",
  EMAIL_INVALID: "Invalid Email",

  NAME_REQUIRED: " is Required",
  NAME_INVALID: "Invalid",

  PASSWORD_REQUIRED: "Password is Required",
  PASSWORD_INVALID: "Invalid Password",

  CONFIRM_PASSWORD_REQUIRED: "Confirm Password is Required",
  CONFIRM_PASSWORD_INVALID: "Passwords Must Match",

  BUSSINESS_REQUIRED: "Business Name is Required",
  BUSSINESS_INVALID: "Invalid Business Name",

  PHONE_REQUIRED: "Phone is Required",
  PHONE_INVALID: "Invalid Mobile Number",

  GENDER_REQUIRED: "Select Gender",

  POSTAL_CODE_INVALID: "Postal Code Invalid",

  TIME_REQUIRED: "Time is Required",
  TIME_INVALID: "Invalid Time",

  PRICE_REQUIRED: "Price is Required",
  PRICE_INVALID: "Price should not be in decimal value",

  SERVICE_OPTION_REQUIRED: "Please select at least one option",

  CLIENT_REQUIRED: "Client is Required",
};

export const staffOptionsValue = {
  manage_staff: "manage team",
  scheduler: "scheduler",
  details: "details",
  services: "services",
  schedule: "schedule",
  comissions: "comissions", // add en
};

export const errorMessages = {
  SELECT_CATEGORY: "Select services",
};

export const appointmentSuccessColumns = {
  SERVICES: "service",
  START_TIME: "start_time",
  END_TIME: "end_time",
  TIME: "time",
  PRICE: "price",
  STAFF: "staff",
  TOTAL_TIME: "total_time",
  TOTAL_AMOUNT: "total_amount",
  BALANCE_AMOUNT: "balance_amount",
};

export const constantMessages = {
  ERR0000: "ERR0000",
  ERR0001: "ERR0001",
  ERR0002: "ERR0002",
  ERR0003: "ERR0003",
  ERR0004: "ERR0004",
  ERR0005: "ERR0005",
  ERR0006: "ERR0006",
  ERR0007: "ERR0007",
  ERR0008: "ERR0008",
  ERR0009: "ERR0009",
  ERR0010: "ERR0010",
  ERR0011: "ERR0011",
  ERR0012: "ERR0012",

  VAL0000: "VAL0000",
  VAL0001: "VAL0001",
  VAL0002: "VAL0002",
  VAL0003: "VAL0003",
  INFO0000: "INFO0000",
  INFO0001: "INFO0001",
  INFO0002: "INFO0002",
  INFO0003: "INFO0003",
  INFO0004: "INFO0004",
  INFO0005: "INFO0005",
  INFO0006: "INFO0006",
  INFO0007: "INFO0007",
  INFO0008: "INFO0008",
  INFO0009: "INFO0009",

  INFO0010: "INFO0010",
  INFO0011: "INFO0011",
  INFO0012: "INFO0012",
  INFO0013: "INFO0013",
  INFO0014: "INFO0014",
  INFO0015: "INFO0015",
  INFO0016: "INFO0016",
  INFO0017: "INFO0017",

  INFO0018: "INFO0018",
  INFO0019: "INFO0019",
  INFO0020: "INFO0020",
  INFO0021: "INFO0021",
  INFO0022: "INFO0022",
  INFO0023: "INFO0023",
  INFO0024: "INFO0024",
  INFO0025: "INFO0025",

  INFO0026: "INFO0026",
  INFO0027: "INFO0027",
  INFO0028: "INFO0028",
  INF00029: "INF00029",
  INF00030: "INF00030",
  INF00031: "INF00031",
  INF00032: "INF00032",
  INF00033: "INF00033",

  INFO0034: "INFO0034",
  INFO0035: "INFO0035",
  INFO0036: "INFO0036",
  INFO0037: "INFO0037",
  INFO0038: "INFO0038",
  INFO0039: "INFO0039",
  INFO0040: "INFO0040",
  INFO0041: "INFO0041",

  INFO0042: "INFO0042",
  INFO0043: "INFO0043",
  INFO0044: "INFO0044",
  INFO0045: "INFO0045",
};
